import moment from 'moment';

export const dateFormatForApiRequest = (date: string | Date) => {
  return moment(date).toISOString();
};
